import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  \n  padding: 8px 12px;\n\n  background-color: ", ";\n  color: ", ";\n  border-radius: 0;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  margin-left: 8px;\n  flex-shrink: 0;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import InfoWithIcons, { InfoWithIconsPlaceholder } from '../../Info/InfoWithIcons';
import InfoButton from '../../Info/InfoButton';
import SvgIcon from '../../SvgIcon';
import { ICON_SIZE } from '../../constants';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, INACTIVE_GRAY, LINE_GRAY, NIGHTINGALE_BLACK, SENSATION_WHITE } from '../../colors';
import Flex from '../../Flex';
import Checkbox from '../Checkbox';
import Toggle from '../Toggle';
import Radio from '../Radio';
import { CHECKBOX_SIZE } from '../Checkbox/constants';
import { RADIO_SIZE } from '../Radio/constants';
import { TOGGLE_WIDTH } from '../Toggle/constants';
import { prevent } from '../../helpers';
import { getPx } from '../../helpers/common';
import { Input as InputSize } from '../../Typography/constants/input.size';
import { baseTextStyle } from '../../Typography/style/base';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
var DROPDOWN_OPTION_LEVEL_OFFSET = 24;
var StyledOptionLabel = styled.span(_templateObject(), function (_ref) {
  var $disabled = _ref.$disabled,
      $focused = _ref.$focused,
      $selected = _ref.$selected,
      $inverse = _ref.$inverse;
  return $disabled ? INACTIVE_GRAY : $focused ? SENSATION_WHITE : $selected ? ADVENTURE_GREEN : $inverse ? SENSATION_WHITE : NIGHTINGALE_BLACK;
}, baseEllipsisStyle);
var StyledOptionHint = styled.span(_templateObject2(), function (_ref2) {
  var $disabled = _ref2.$disabled,
      $focused = _ref2.$focused,
      $selected = _ref2.$selected,
      $inverse = _ref2.$inverse;
  return $disabled ? INACTIVE_GRAY : $focused ? SENSATION_WHITE : $selected ? ADVENTURE_GREEN : $inverse ? LINE_GRAY : INACTIVE_GRAY;
}, baseEllipsisStyle);
var StyledOption = styled(InfoButton)(_templateObject3(), baseTextStyle, baseSelectionStyle, baseHighlightStyle, userSelectNoneStyle, fontSize(InputSize.fontSize), lineHeight(InputSize.lineHeight), function (_ref3) {
  var $focused = _ref3.$focused,
      disabled = _ref3.disabled;
  return $focused ? disabled ? LINE_GRAY : ADVENTURE_GREEN : 'transparent';
}, function (_ref4) {
  var disabled = _ref4.disabled,
      $focused = _ref4.$focused,
      $selected = _ref4.$selected,
      $inverse = _ref4.$inverse;
  return disabled ? INACTIVE_GRAY : $focused ? SENSATION_WHITE : $selected ? ADVENTURE_GREEN : $inverse ? SENSATION_WHITE : NIGHTINGALE_BLACK;
}, function (_ref5) {
  var inactive = _ref5.inactive,
      disabled = _ref5.disabled,
      $hasInput = _ref5.$hasInput,
      $noHover = _ref5.$noHover;
  return !inactive && !disabled && !$noHover && "\n    &:active {\n      background-color: " + ADVENTURE_GREEN_FOCUSED + ";\n      color: " + SENSATION_WHITE + ";\n      " + StyledOptionLabel + " {\n        color: " + SENSATION_WHITE + ";\n      }\n      " + StyledOptionHint + " {\n        color: " + SENSATION_WHITE + ";\n      }\n      " + (!$hasInput && "\n        " + InfoWithIconsPlaceholder + " svg {\n          fill: " + SENSATION_WHITE + ";\n        }\n      ") + "\n    }\n    &:hover {\n      background-color: " + ADVENTURE_GREEN + ";\n      color: " + SENSATION_WHITE + ";\n      " + StyledOptionLabel + " {\n        color: " + SENSATION_WHITE + ";\n      }\n      " + StyledOptionHint + " {\n        color: " + SENSATION_WHITE + ";\n      }\n      " + (!$hasInput && "\n        " + InfoWithIconsPlaceholder + " svg {\n          fill: " + SENSATION_WHITE + ";\n        }\n      ") + "\n    }\n  ";
});
var StyledInfoWithIcons = styled(InfoWithIcons)(_templateObject4(), function (_ref6) {
  var _ref6$$level = _ref6.$level,
      $level = _ref6$$level === void 0 ? 0 : _ref6$$level;
  return "margin-left: " + getPx($level * DROPDOWN_OPTION_LEVEL_OFFSET);
});
var DropdownOption = /*#__PURE__*/React.forwardRef(function (_ref7, forwardedRef) {
  var _custom$label, _custom$hint;

  var _onClick = _ref7.onClick,
      _ref7$inverse = _ref7.inverse,
      inverse = _ref7$inverse === void 0 ? false : _ref7$inverse,
      _ref7$ellipsis = _ref7.ellipsis,
      ellipsis = _ref7$ellipsis === void 0 ? false : _ref7$ellipsis,
      _ref7$disabled = _ref7.disabled,
      disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
      _ref7$selected = _ref7.selected,
      selected = _ref7$selected === void 0 ? false : _ref7$selected,
      _ref7$focused = _ref7.focused,
      focused = _ref7$focused === void 0 ? false : _ref7$focused,
      _ref7$inactive = _ref7.inactive,
      inactive = _ref7$inactive === void 0 ? false : _ref7$inactive,
      _ref7$noHover = _ref7.noHover,
      noHover = _ref7$noHover === void 0 ? false : _ref7$noHover,
      option = _ref7.option,
      props = _objectWithoutPropertiesLoose(_ref7, ["onClick", "inverse", "ellipsis", "disabled", "selected", "focused", "inactive", "noHover", "option"]);

  var custom = option.custom,
      labelProp = option.label,
      hintProp = option.hint,
      icon = option.icon,
      image = option.image,
      _option$checkbox = option.checkbox,
      checkbox = _option$checkbox === void 0 ? false : _option$checkbox,
      _option$toggle = option.toggle,
      toggle = _option$toggle === void 0 ? false : _option$toggle,
      _option$radio = option.radio,
      radio = _option$radio === void 0 ? false : _option$radio,
      _option$level = option.level,
      level = _option$level === void 0 ? 0 : _option$level;
  var label = (_custom$label = custom == null ? void 0 : custom.label) != null ? _custom$label : labelProp;
  var hint = (_custom$hint = custom == null ? void 0 : custom.hint) != null ? _custom$hint : hintProp;
  return /*#__PURE__*/React.createElement(StyledOption, _extends({
    fullWidth: true,
    clickable: !inactive && !disabled,
    ref: forwardedRef,
    inactive: inactive,
    disabled: disabled,
    onClick: _onClick,
    $selected: selected,
    $focused: focused,
    $inverse: inverse,
    $hasInput: checkbox || toggle,
    $noHover: noHover
  }, props), /*#__PURE__*/React.createElement(StyledInfoWithIcons, {
    $level: level,
    fullInnerWidth: true,
    withInnerOverflowHidden: true,
    size: 'input',
    multiline: true,
    ellipsis: ellipsis || checkbox || toggle || radio || icon,
    icon: checkbox ? /*#__PURE__*/React.createElement(Checkbox, {
      checked: selected,
      borderColor: selected ? SENSATION_WHITE : undefined,
      onClick: function onClick(e) {
        prevent(e);
        _onClick == null ? void 0 : _onClick(e);
      }
    }) : toggle ? /*#__PURE__*/React.createElement(Toggle, {
      checked: selected,
      borderColor: selected ? SENSATION_WHITE : undefined,
      onClick: function onClick(e) {
        prevent(e);
        _onClick == null ? void 0 : _onClick(e);
      }
    }) : radio ? /*#__PURE__*/React.createElement(Radio, {
      checked: selected,
      onClick: function onClick(e) {
        prevent(e);
        _onClick == null ? void 0 : _onClick(e);
      }
    }) : icon ? /*#__PURE__*/React.createElement(SvgIcon, {
      size: ICON_SIZE,
      color: disabled ? ELEMENT_GRAY : focused ? SENSATION_WHITE : selected ? ADVENTURE_GREEN : inverse ? LINE_GRAY : ELEMENT_GRAY
    }, icon) : image || null,
    iconWidth: checkbox ? CHECKBOX_SIZE : toggle ? TOGGLE_WIDTH : radio ? RADIO_SIZE : ICON_SIZE
  }, hint ? /*#__PURE__*/React.createElement(Flex, {
    as: 'span',
    direction: 'ltr',
    alignItems: 'center',
    justifyContent: 'between'
  }, /*#__PURE__*/React.createElement(StyledOptionLabel, {
    $selected: selected,
    $disabled: disabled,
    $focused: focused,
    $inverse: inverse
  }, label), /*#__PURE__*/React.createElement(StyledOptionHint, {
    $selected: selected,
    $disabled: disabled,
    $focused: focused,
    $inverse: inverse
  }, hint)) : label));
});
export default DropdownOption;